import { render } from "./EmailConsultPanelItem.vue?vue&type=template&id=001f972c&scoped=true"
import script from "./EmailConsultPanelItem.vue?vue&type=script&lang=js"
export * from "./EmailConsultPanelItem.vue?vue&type=script&lang=js"

import "./EmailConsultPanelItem.vue?vue&type=style&index=0&id=001f972c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001f972c"]])

export default __exports__